export default [{
  path: '/contributionManagement',
  name: '',
  component: resolve => require(['@/views/home'], resolve),
  children: [
    {
      path: 'draftBox',
      name: '草稿箱',
      meta: {
        title: '草稿箱'
      },
      component: resolve => require(['@/views/contributionManagement/draftBox'], resolve),
    },
    {
      path: 'mySubmission',
      name: '我的投稿',
      meta: {
        title: '我的投稿'
      },
      component: resolve => require(['@/views/contributionManagement/mySubmission'], resolve),
    },
    {
      path: 'paymentConfirmation',
      name: '订单确认',
      meta: {
        title: '订单确认'
      },
      component: resolve => require(['@/views/contributionManagement/paymentConfirmation'], resolve),
    },
    // {
    //   path: 'notice',
    //   name: '通知书',
    //   meta: {
    //     title: '通知书'
    //   },
    //   component: resolve => require(['@/views/contributionManagement/notice'], resolve),
    // }
  ]
},
{
  path: '/contributionManagement/notice',
  name: '通知书',
  meta: {
    title: '通知书'
  },
  component: resolve => require(['@/views/contributionManagement/notice'], resolve),
}
]




// WEBPACK FOOTER //
// ./src/router/contributionManagement_routers.js